import { CONVERSATION_CONSTANTS } from "../helpers/constants";
import { friendlyActorName } from "../helpers/conversationEntryUtil";
import { t, useAwacLang } from "../awac/i18n";

import "./typingIndicator.css";

export default function TypingIndicator(props) {
    // Re-render the label when the page language toggles.
    useAwacLang();

    /**
     * Label under the animated dots. When a participant explicitly reported
     * typing, name them; otherwise this is the client-side "agent is working
     * on a reply" state (the agent plans/calls actions without sending typing
     * events), so show a generic thinking label.
     * @returns {string}
     */
    function getTypingIndicatorText() {
        const participants = props.typingParticipants || {};
        const nameList = Object.keys(participants);

        if (nameList.length > 1) {
            return t("chat.multipleTyping");
        }
        if (nameList.length === 1) {
            const p = participants[nameList[0]] || {};
            if (p.role === CONVERSATION_CONSTANTS.ParticipantRoles.AGENT) {
                // A HUMAN service rep typing keeps their (friendly) name.
                return t("chat.isTyping", { name: friendlyActorName(nameList[0], p.role) });
            }
        }
        // The bot typing, or the synthetic thinking state: always Lia —
        // internal bot/deployment names (e.g. "Pilot Buyer Engagement V3")
        // never surface to the prospect.
        return t("chat.agentThinking");
    }

    return (
        <>
            <div className="typingIndicatorContainer">
                <div className="typingIndicatorBubbleContainer">
                    <div className="typingIndicatorBubble">
                        <span className="loadingBall first"></span>
                        <span className="loadingBall second"></span>
                        <span className="loadingBall third"></span>
                    </div>
                </div>
                <p className="typingIndicatorSenderContent">{getTypingIndicatorText()}</p>
            </div>
        </>
    );
}
